import React from 'react';
import { CategoryIcon } from '../ui/CategoryIcon';

interface CategoryChipProps {
  label: string;
  icon?: string;
  active?: boolean;
  onClick?: () => void;
  className?: string;
}

// Calca CategoryChip de components.jsx (Claude Design)
export const CategoryChip: React.FC<CategoryChipProps> = ({ label, icon, active = false, onClick, className = '' }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3.5 py-2 text-[13px] font-semibold whitespace-nowrap shrink-0 transition-all duration-150 ${
        active
          ? 'bg-primary-500 border-primary-500 text-white'
          : 'bg-surface border-outlineVarWarm text-onSurface hover:border-primary-300'
      } ${className}`}
    >
      {icon && <CategoryIcon name={icon} size={16} />}
      {label}
    </button>
  );
};
